import { render } from "./BundleChoice.vue?vue&type=template&id=1cb9a228&scoped=true"
import script from "./BundleChoice.vue?vue&type=script&lang=js"
export * from "./BundleChoice.vue?vue&type=script&lang=js"

import "./BundleChoice.vue?vue&type=style&index=0&id=1cb9a228&lang=scss&scoped=true"

import exportComponent from "/Users/jason.pollock/Containers/globaltech/packages/fool-wp-commerce/vue-commerce/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb9a228"]])

export default __exports__